import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import HeaderPublic from '../../components/headerPublic/index.js'
import Footer from '../../components/footer/index.js'
import Faq from '../../components/faq/index.js';

import './styles.css'



const Help = () => {

    const accordion = [
        {
            "title": "Como acessar a plataforma coedados sendo colaborador Natura?",
            "body": "Desde Julho / 2026 a autenticação no Portal é feita através de Google SSO, cujo o Login é exclusivo para Emails Google com domínio natura.net"
        },
        {
            "title": "Como resolver erros comuns ao tentar logar no portal?",
            "body": CommonPortalErrors()
        },
        {
            "title": "Como solicitar a mudança de perfil do meu usuário na plataforma coedados?",
            "body": "Um Ticket deve ser aberto para a equipe de Plataforma de Dados, incluindo o e-mail que deseja mudar o perfil assim como o perfil desejado (engenheiro de dados|cientista de dados|governança de dados). Lembrando que será realizada uma análise antes de conceder o acesso solicitado."
        },
        {
            "title": "Precisa de suporte, relatar erros ou fornecer sugestões e/ou feedbacks?",
            "body": "Um Ticket deve ser aberto para a equipe de Plataforma de Dados, procure detalhar o problema para facilitar a análise."
        }
    ]

    return (
        <div className='help-container'>
            <HeaderPublic />

            <Faq accordion={accordion} />

            <Footer />
        </div>
    );
}


const CommonPortalErrors = () => (
    <div>
        <div>
            <p><b>- Usuário não ativo:</b></p>
            <p className='help-recuo'>
                Verique sua caixa de e-mail, inclusive o spam, e procure pelo título <b>Finalizar Cadastro</b> enviado por <b>no-reply@{process.env.REACT_APP_ENVIRONMENT}.naturacloud.com</b>
                , siga as orientações do e-mail pra finalizar seu cadastro.
            </p>
            <p className='help-recuo'>
                Esse processo é exclusivo para colaboradores Natura&CO.
            </p>
            <br />
            <p><b>- Usuário não cadastrado:</b></p>
            <p className='help-recuo'>
                A autenticação por Google SSO é exclusiva para emails com domínio <b>natura.net</b>.
            </p>
            <br />
            <p><b>- Usuário sem permissão:</b></p>
            <p className='help-recuo'>
                O portal coedados é exclusivo para colaboradores Natura&CO.
            </p>
            <p className='help-recuo'>
                Abra um Ticket para equipe de plataforma de dados do D&A Hub relatando brevemente seu problema.
            </p>
        </div>
    </div>
)


const RegisterUserPortal = () => {
    const link = "https://portal.natura-coedados-" + process.env.REACT_APP_ENVIRONMENT + ".naturacloud.com/cadastro-novo-usuario"

    return (
        <div>
            <div>
                <p className='help-recuo'>
                    Para acessar a plataforma coedados será necessário realizar um cadastro prévio na plataforma, isso pode ser feito <a href={link}>clicando aqui</a>.
                </p>
                <br />
                <p className='help-recuo'>
                    Após cadastrar-se no link acima, você receberá um e-mail com instruções para criar sua senha de acesso e complementar seu cadastro.
                </p>
            </div>
        </div>
    )
}


const ResetPasswordPortal = () => {
    const link = "https://portal.natura-coedados-" + process.env.REACT_APP_ENVIRONMENT + ".naturacloud.com/cadastro-nova-senha"

    return (
        <div>
            <div>
                <p className='help-recuo'>
                    Para alterar sua senha <a href={link}>clique aqui</a>
                </p>
                <br />
                <p className='help-recuo'>
                    Após cadastrar-se no link acima, você receberá um e-mail com instruções para criar sua senha de acesso e complementar seu cadastro.
                </p>
            </div>
        </div>
    )
}


export default Help;
